import { render } from "./BannerImg.vue?vue&type=template&id=2afd7410&scoped=true"
import script from "./BannerImg.vue?vue&type=script&lang=js"
export * from "./BannerImg.vue?vue&type=script&lang=js"

import "./BannerImg.vue?vue&type=style&index=0&id=2afd7410&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afd7410"]])

export default __exports__